import { render, staticRenderFns } from "./TrackingPayPalTable.vue?vue&type=template&id=5273ec67&scoped=true"
import script from "./TrackingPayPalTable.vue?vue&type=script&lang=js"
export * from "./TrackingPayPalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5273ec67",
  null
  
)

export default component.exports